/**
 * TOPページ メインビジュアル（ヒーローイメージ）
 */
import Swiper from 'swiper';

module.exports = (() => {
    const hero = new Swiper(`.s-hero .swiper-container`, {
        autoplay: {
            delay: 3000,
        },
        fadeEffect: {
            crossFade: true,
        },
        speed: 2000,
        effect: `fade`,
        loop: true,
    });

    return hero;
})();


// WEBPACK FOOTER //
// ./js/modules/hero.js